import en from './en.json';
import uk from './uk.json';
import pl from './pl.json';
import ru from './ru.json';
import es from './es.json';
import uz from './uz.json';
import hi from './hi.json';
import { createLocale } from '../../utils.js';

const locales = {
  en: createLocale(en, 'checklists'),
  uk: createLocale(uk, 'checklists'),
  pl: createLocale(pl, 'checklists'),
  ru: createLocale(ru, 'checklists'),
  es: createLocale(es, 'checklists'),
  uz: createLocale(uz, 'checklists'),
  hi: createLocale(hi, 'checklists'),
};

export default locales;
